
import React,  { Dispatch, SetStateAction }from 'react';
import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup, Typography } from '@material-ui/core';
import { BatchCorrectionAction, numberToEnum } from '../enum/BatchCorrectionAction';

interface IBatchCorrectionActions {
    value: BatchCorrectionAction,
    setValue: Dispatch<SetStateAction<BatchCorrectionAction>>
}

export function BatchCorrectionActions ({value, setValue} : IBatchCorrectionActions) {
    return (
        <Grid item xs={12}>
            <FormControl component="fieldset">
                <FormLabel component="legend">
                    <Typography variant="subtitle1">Ação</Typography>
                </FormLabel>
                <RadioGroup 
                    row
                    aria-label="source-correction" 
                    value={value} 
                    name="correct_vehicle" 
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => setValue(numberToEnum(parseFloat(event.target.value))) }>
                    <FormControlLabel
                        value={BatchCorrectionAction.ADD}
                        control={<Radio color='primary' size='small' />}
                        label={<Typography variant="body2" color="textPrimary">Adicionar</Typography>} />
                    <FormControlLabel
                        value={BatchCorrectionAction.REMOVE}
                        control={<Radio color='primary' size='small' />}
                        label={<Typography variant="body2" color="textPrimary">Excluir</Typography>} />
                </RadioGroup>
            </FormControl>
        </Grid>
    );
}